export default __webpack_public_path__ + "static/media/icon-circle-guarantors.a32f0144.svg";